var _defs, _path, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInheritanceTax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #73151f;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300,247.8c-52.94,0-96.01-43.07-96.01-96.01s43.07-96.01,96.01-96.01,96.01,43.07,96.01,96.01-43.07,96.01-96.01,96.01ZM300,65.79c-47.42,0-86.01,38.58-86.01,86.01s38.58,86.01,86.01,86.01,86.01-38.58,86.01-86.01-38.58-86.01-86.01-86.01Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M428.27,544.21c-52.94,0-96-43.07-96-96s43.07-96.01,96-96.01,96.01,43.07,96.01,96.01-43.07,96-96.01,96ZM428.27,362.2c-47.42,0-86,38.58-86,86.01s38.58,86,86,86,86.01-38.58,86.01-86-38.58-86.01-86.01-86.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.73,544.21c-52.94,0-96.01-43.07-96.01-96s43.07-96.01,96.01-96.01,96,43.07,96,96.01-43.07,96-96,96ZM171.73,362.2c-47.42,0-86.01,38.58-86.01,86.01s38.58,86,86.01,86,86-38.58,86-86-38.58-86.01-86-86.01Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M428.27,336c-2.76,0-5-2.24-5-5v-25.26h-246.54v25.26c0,2.76-2.24,5-5,5s-5-2.24-5-5v-30.26c0-2.76,2.24-5,5-5h256.54c2.76,0,5,2.24,5,5v30.26c0,2.76-2.24,5-5,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300,305.74c-2.72,0-4.95-2.18-5-4.91l-.6-32.8c-.05-2.76,2.15-5.04,4.91-5.09,2.73-.06,5.04,2.15,5.09,4.91l.6,32.8c.05,2.76-2.15,5.04-4.91,5.09-.03,0-.06,0-.09,0Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.4,157.49c-16.54,0-30-13.46-30-30s13.46-30,30-30,30,13.46,30,30-13.46,30-30,30ZM299.4,107.5c-11.03,0-20,8.97-20,20s8.97,20,20,20,20-8.97,20-20-8.97-20-20-20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M341.63,199.72c-2.76,0-5-2.24-5-5,0-20.53-16.7-37.23-37.23-37.23s-37.23,16.7-37.23,37.23c0,2.76-2.24,5-5,5s-5-2.24-5-5c0-26.04,21.19-47.23,47.23-47.23s47.23,21.19,47.23,47.23c0,2.76-2.24,5-5,5Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M428.27,453.25c-16.54,0-30-13.46-30-30s13.46-30,30-30,30,13.46,30,30-13.46,30-30,30ZM428.27,403.26c-11.03,0-20,8.97-20,20s8.97,20,20,20,20-8.97,20-20-8.97-20-20-20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M470.5,495.48c-2.76,0-5-2.24-5-5,0-20.53-16.7-37.23-37.23-37.23s-37.23,16.7-37.23,37.23c0,2.76-2.24,5-5,5s-5-2.24-5-5c0-26.04,21.19-47.23,47.23-47.23s47.23,21.19,47.23,47.23c0,2.76-2.24,5-5,5Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.73,453.25c-16.54,0-30-13.46-30-30s13.46-30,30-30,30,13.46,30,30-13.46,30-30,30ZM171.73,403.26c-11.03,0-20,8.97-20,20s8.97,20,20,20,20-8.97,20-20-8.97-20-20-20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.96,495.48c-2.76,0-5-2.24-5-5,0-20.53-16.7-37.23-37.23-37.23s-37.23,16.7-37.23,37.23c0,2.76-2.24,5-5,5s-5-2.24-5-5c0-26.04,21.19-47.23,47.23-47.23s47.23,21.19,47.23,47.23c0,2.76-2.24,5-5,5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInheritanceTax);
export default __webpack_public_path__ + "static/media/Inheritance_Tax.8156c437928ef2a0e1696c86bc60b083.svg";
export { ForwardRef as ReactComponent };